var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c('div',{staticClass:"form-floating"},[_c('textarea',{staticClass:"form-control",class:{ 
			'is-valid': _vm.validator && !_vm.validator.$error && _vm.validator.$dirty, 
			'is-invalid': _vm.validator && _vm.validator.$error,
			inputClass: _vm.inputClass
			},style:(_vm.heightStyle),attrs:{"name":_vm.name,"placeholder":"placeholder"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }